import { Component, inject, input, OnDestroy, OnInit, output, signal } from "@angular/core";
import { NavTopComponent } from "./nav-top/nav-top.component";
import { Router, RouterModule } from "@angular/router";

import { ENVIRONMENT, User } from "@company-box/models";

@Component({
  selector: "app-header",
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.scss"],
  imports: [RouterModule, NavTopComponent],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private environment = inject(ENVIRONMENT);

  user = input<User | undefined>(undefined);
  navbarOpen = input(false);
  cartEmpty = input(false);

  toggleMenu = output();
  toggleLogin = output();
  toggleLogout = output();

  config = signal<any>({});

  constructor() {}

  ngOnInit(): void {
    this.config.set(this.environment.config);
  }

  ngOnDestroy(): void {
    throw new Error("Method not implemented.");
  }

  redirect() {
    this.router.navigate(["/rewards"]);
  }
}
